export type ShopifyStatus = {
  connected: boolean;
  shopify_connector_active?: boolean;
  can_use_shopify?: boolean;
  pricing_required?: boolean;

  pricing_url?: string | null;
  pricing_deep_link?: string | null;
  installed_app_url?: string | null;
  shopify_admin_app_url?: string | null;

  app_handle?: string | null;
  store_handle?: string | null;
  shop_domain?: string | null;

  requires_reconnect?: boolean;
  reconnect_required?: boolean;
  token_health?: string | null;
  status?: string | null;

  default_payout_bank_account_id?: string | number | null;
};

export function isShopifyBillingRequired(
  status: ShopifyStatus | null | undefined
): boolean {
  if (!status?.connected) return false;

  const reconnectRequired =
    status.requires_reconnect === true ||
    status.reconnect_required === true ||
    status.token_health === "reconnect_required" ||
    status.status === "reconnect_required";

  if (reconnectRequired) return false;

  return (
    status.pricing_required === true ||
    status.shopify_connector_active === false ||
    status.can_use_shopify === false
  );
}